import { motion } from "framer-motion";
import { ReactNode } from "react";

type DropdownItemsFramerProps = {
  children: ReactNode; // Optional children prop
  className?: string;
};

export default function DropdownItemsFramer({ children, className }: DropdownItemsFramerProps) {
  const dropdownVariants = {
    hidden: { opacity: 0, y: -20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.3,
        staggerChildren: 0.1, // Stagger appearance of children
      },
    },
    exit: {
      opacity: 0,
      y: -20,
      transition: {
        duration: 0.3,
        staggerChildren: 0.1, // Stagger disappearance of children
        staggerDirection: -1, // Reverse order during exit
      },
    },
  };
  return (
    <motion.div
      variants={dropdownVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className={className}
    >
      {children}
    </motion.div>
  );
}
